import { FC, SyntheticEvent, useContext, useMemo } from 'react';

import classNames from 'classnames';

import ExpandableSection, {
  ExpandableSectionProps,
} from '../ExpandableSection';
import { MenuItem } from '../Menu';
import { ExpandableMenuContext } from './ExpandableMenu';

import './ExpandableMenuSection.scss';

export type ExpandableMenuSectionProps = Omit<
  ExpandableSectionProps,
  'isExpanded'
> & {
  onClick: (e: SyntheticEvent<HTMLLIElement>) => void;
  isActive?: boolean;
};

const ExpandableMenuSection: FC<ExpandableMenuSectionProps> = ({
  children,
  className,
  mainSection,
  onClick,
  containerProps,
  testMetadata,
  isActive,
  ...otherProps
}) => {
  const { isExpanded } = useContext(ExpandableMenuContext);

  const menuItemClasses = useMemo(
    () =>
      classNames(
        'sb-expandable-menu-section',
        {
          'sb-expandable-menu-section__active': isActive,
          'sb-expandable-menu-section__expanded': isExpanded,
          'sb-expandable-menu-section__collapsed': !isExpanded,
        },
        className,
      ),
    [isActive, isExpanded, className],
  );

  return (
    <MenuItem className={menuItemClasses} onClick={onClick} {...otherProps}>
      <ExpandableSection
        isExpanded={isExpanded}
        mainSection={mainSection}
        containerProps={containerProps}
        testMetadata={testMetadata}
        className="sb-expandable-menu-section__expandable-section"
      >
        {children}
      </ExpandableSection>
    </MenuItem>
  );
};

export default ExpandableMenuSection;
